import { Helper } from './helper'

export const userGuiding = {
  methods: {
    identifierUserGuiding() {
      const userId = Helper.methods.getUserId()
      const userName = Helper.methods.getUserName()
      const userEmail = Helper.methods.getUserEmail()
      const companyId = Helper.methods.getCompanyId()
      const companyName = Helper.methods.getCompanyName()
      const domain = window.location.hostname
      if (window.userGuiding) {
        window.userGuiding.identify(userId, {
          name: userName,
          email: userEmail,
          domain: domain,
          company: {
            id: companyId,
            name: companyName,
          },
        })
      } else {
        console.error('UserGuiding is not loaded yet.')
      }
    },
  },
}
